import React from "react";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";
import north from "../../assets/images/restore/northRestore.webp";
import south from "../../assets/images/restore/southRestore.webp";
import CTASection from "../../components/CTASection"; // Ensure the correct path to CTASection component

const LocationAndHours = () => {
  return (
    <>
      <Helmet>
        <title>
          ReStore Locations and Hours - Habitat for Humanity Buffalo
        </title>
        <meta
          name="description"
          content="Visit Habitat for Humanity Buffalo ReStores for incredible deals on new or gently-used furniture, appliances, home decor, and building materials. Check our locations and hours."
        />
      </Helmet>
      <Container>
        <Title>ReStore Locations and Hours</Title>
        <Paragraph>
          Come visit us at our home improvement thrift stores! We have new
          inventory every day that will inspire you to create the home of your
          dreams. Find incredible deals on new or gently-used furniture,
          appliances, home decor, building materials, doors, windows, flooring,
          kitchen cabinets, and so much more at our Habitat for Humanity Buffalo
          ReStores. We have two locations to serve you, locations and hours are
          below for your reference.
        </Paragraph>

        <StoreHoursSection>
          <StoreLocation>
            <LazyLoad height={200} offset={100}>
              <StoreImage src={south} alt="South Buffalo ReStore" />
            </LazyLoad>
            <h3 className="project-title">South Buffalo ReStore</h3>
            <p className="project-description">
              1675 South Park Ave, Buffalo, NY 14220
              <br />
              Phone: (716) 204-0740 ext. 302
              <br />
              <hr />
              <strong>Hours of Operation:</strong>
              <br />
              Tuesday - Saturday 10:00am to 5:00pm
              <br />
              Closed Sunday and Monday
            </p>
            <ButtonContainer>
              <a
                href="https://goo.gl/maps/xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="button primary"
              >
                VIEW MAP
              </a>
            </ButtonContainer>
          </StoreLocation>
          <StoreLocation>
            <LazyLoad height={200} offset={100}>
              <StoreImage src={north} alt="Tonawanda ReStore" />
            </LazyLoad>
            <h3 className="project-title">Tonawanda ReStore</h3>
            <p className="project-description">
              1030 Niagara Falls Blvd, Tonawanda, NY 14150
              <br />
              Phone: (716) 204-0740 ext. 203
              <br />
              <hr />
              <strong>Hours of Operation:</strong>
              <br />
              Tuesday - Saturday 10:00am to 7:00pm
              <br />
              Closed Sunday and Monday
            </p>
            <ButtonContainer>
              <a
                href="https://goo.gl/maps/xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="button primary"
              >
                VIEW MAP
              </a>
            </ButtonContainer>
          </StoreLocation>
        </StoreHoursSection>
        <CTASection
          title="ReStore eBay Store"
          description="Visit our online ReStore for a curated selection of unique items, collectibles, and all sorts of treasures. Your purchases help support Habitat Buffalo's mission to build homes for families in need."
          buttonText="VIEW STORE"
          buttonLink="https://www.ebay.com/str/habitatforhumanitybuffalo"
        />
      </Container>
    </>
  );
};

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  font-size: 1.1em;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: center;
`;

const SectionHeader = styled.div`
  text-align: center;
  font-size: 1.2em;
  margin: 20px 0;
  padding: 10px;
  background-color: ${(props) =>
    props.className.includes("orange")
      ? "var(--hhb-orange)"
      : "var(--hhb-primary)"};
  color: #fff;
  border-radius: 8px;
`;

const StoreHoursSection = styled.div`
  text-align: center;
  padding: 20px 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
`;

const StoreLocation = styled.div`
  flex: 1 1 45%;
  max-width: 600px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;

  img {
    width: 100%;
    border-radius: 8px;
    margin-bottom: 15px;
  }

  p {
    text-align: left;
  }

  .button.primary {
    display: inline-block;
    padding: 10px 20px;
    background-color: var(--hhb-green);
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 10px;
  }

  .button.primary:hover {
    background-color: var(--hhb-primary);
  }
`;

const StoreImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default LocationAndHours;
